module.exports = __webpack_public_path__ + "img/menu-app-fill.9a5aab4b.svg";